'use strict';

var _ = require('lodash');
var ConfigurationMarketAssignTransformerFactory = function ConfigurationMarketAssignTransformerFactory(DataTransformer) {
  function ConfigurationMarketAssingTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-market-assign-mode';
  }
  function formatYesNo(booleanValue) {
    return booleanValue ? 'Yes' : 'No';
  }
  ConfigurationMarketAssingTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationMarketAssingTransformer.constructor = ConfigurationMarketAssingTransformer;
  ConfigurationMarketAssingTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationMarketAssingTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationMarketAssingTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationMarketAssingTransformer.prototype.transform = function (data) {
    var transformed = [];
    for (var index = 0, dataLength = data.domain.flattenedMarketEntities.length; index < dataLength; index++) {
      transformed[index] = data.domain.flattenedMarketEntities[index];
      transformed[index].isSignificantOriginal = transformed[index].isSignificant;
      transformed[index].isSignificant = formatYesNo(transformed[index].isSignificant);
      transformed[index].isLocal = formatYesNo(transformed[index].isLocal);
      transformed[index].isTrafficRestricted = formatYesNo(transformed[index].isTrafficRestricted);
      transformed[index].isFimAlertEnabled = formatYesNo(_.get(transformed[index], 'isFimAlertEnabled', true));
      transformed[index].forecastType = transformed[index].forecastType || 'Market';
      transformed[index].isInterline = formatYesNo(transformed[index].isInterline);
    }
    return transformed;
  };
  return ConfigurationMarketAssingTransformer;
};
ConfigurationMarketAssignTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ConfigurationMarketAssignTransformerFactory;